import { config } from "@oysterhr/core"
import { STORED_ASPECT, STORED_ASPECT_TYPE } from "../../AccountAspectContext"
import { useCsrfContext } from "../../CsrfContext"

const SIGN_OUT_URL = `${config?.endpoints?.app}/users/sign_out`

export const useLogout = () => {
  const token = useCsrfContext()
  const url = new URL(window.location.href)

  const handleLogout = () =>
    fetch(SIGN_OUT_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ authenticity_token: token || "" }),
    }).then(() => {
      window.localStorage.removeItem(STORED_ASPECT)
      window.localStorage.removeItem(STORED_ASPECT_TYPE)
      window.location.href = url.origin
    })

  return { handleLogout }
}
